export const comparators = {
	recommendation: (a, b) => (b?.ranking || 0) - (a?.ranking || 0),
	price_asc: (a, b) => (a?.total ?? 0) - (b?.total ?? 0),
	price_desc: (a, b) => (b?.total ?? 0) - (a?.total ?? 0),
	rating_desc: (a, b) => (b?.tripadvisor?.rating ?? 0) - (a?.tripadvisor?.rating ?? 0),
	stars_desc: (a, b) => (b?.category ?? 0) - (a?.category ?? 0),
	discount_desc: (a, b) => {
		const byPercentage = (b?.discountPercentage ?? 0) - (a?.discountPercentage ?? 0);
		if (byPercentage !== 0) {
			return byPercentage;
		}
		return (Number(b?.discountValue) || 0) - (Number(a?.discountValue) || 0);
	},
};
